import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import logo from "../../assets/img/logo-full.png";

const Footer = () => {
  const Year = moment().year()
  return (
    <footer className="page-footer px-xl-4 px-sm-2 px-0 py-3">
  <div className="container-fluid d-flex flex-wrap justify-content-between align-items-center text-md-start text-center">
      <p className="col-md-4 mb-0 text-muted">© {Year} <a href="https://www.tirhelo.co.za/" target="_blank" title="Tirhelo">Tirhelo</a>, All Rights Reserved.</p>
      <Link  className="col-md-4 d-flex align-items-center justify-content-center my-3 my-lg-0 me-lg-auto">
          <img src={logo} alt="Logo" style={{height: 60}}/>
      </Link>
      <ul className="nav col-md-4 justify-content-center justify-content-lg-end">
          <li className="nav-item"><Link to="https://tirhelo.co.za" target="_blank" className="nav-link px-2 text-muted">Support</Link></li>
      </ul>
  </div>
</footer>
  )
}

export default Footer
